/* eslint-disable import/prefer-default-export */
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import SortByOptions, { SortByOptionsStrings } from 'enums/SortByOptions'

export const getSortByOption = (
  viewOption: InsightViewOptionStrings | undefined
): SortByOptionsStrings | never => {
  switch (viewOption) {
    case InsightViewOption.BY_ENGAGEMENTS:
      return SortByOptions.MOST_ENGAGEMENTS
    case InsightViewOption.BY_REPOSTS:
      return SortByOptions.MOST_RETWEETS
    case InsightViewOption.BY_REPLIES:
      return SortByOptions.MOST_REPLIES
    case InsightViewOption.BY_DATE:
      return SortByOptions.MOST_RECENT
    case InsightViewOption.BY_LINK_MENTIONS:
      return SortByOptions.MOST_SHARED
    case InsightViewOption.BY_VIEWS:
      return SortByOptions.MOST_VIEWS
    default:
      throw new Error(`No SortBy specified with viewOption: ${viewOption}'`)
  }
}
